@import '~@customink/design-tokens/build/scss/variables.scss';
@import '../../global-styles/index.scss';
@import '../../respond-to.scss';

$cart-icon-size: $spacing-32;
$cart-badge-size: $spacing-16;

.ciHeader-cart {
  &-count {
    cursor: pointer;
    font-size: $typography-button-small-size;
    position: absolute;
    margin-left: 25px;
    color: $color-shade-white;
    background-color: $color-partnership-bold-default;
    border-radius: 50%;
    text-align: center;
    white-space: nowrap;
    height: $cart-badge-size;
    width: $cart-badge-size;
    line-height: $cart-badge-size;
  }
  &-icon-button {
    padding: $spacing-8;
    border-radius: 40px;
    display: block;
    height: 24px;
    width: 24px;
    box-sizing: content-box;

    &:hover {
      border-radius: 50%;
      background-color: $color-header-hover-blue;
      svg, path {
        fill: $color-blue-default;
      }
    }

    &:active {
      border-radius: 50%;
      background-color: $color-header-hover-blue;
      svg, path {
        fill: $color-blue-default;
      }
    }
  }
}

@include breakpoint('lg') {
  .ciHeader-cart {
    display: flex;
    cursor: pointer;
    height: 40px;
    width: 40px;
    padding-left: 0;

    &-icon {
      margin-top: $spacing-8;
      margin-left: $spacing-8;
      padding: 0;
    }
  }
}

@include breakpoint('xl') {
  .ciHeader-cart {
    display: flex;
    cursor: pointer;
    height: 40px;
    width: 40px;
    padding-left: 0;

    &-icon {
      margin-top: $spacing-8;
      margin-left: $spacing-8;
      padding: 0;
    }
  }
}
